import React from 'react';

import { IconProps } from '../../DefaultIcon';

export function ClientsIcon({ className }: IconProps) {
  return (
    <svg
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_5_5252)">
        <path
          d="M51.4803 63.0815H22.4773V74.6827H51.4803V63.0815Z"
          fill="#EAEEF9"
        />
        <path
          d="M69.849 65.2568H4.59215C2.17523 65.2568 0.241699 63.3232 0.241699 60.9063V15.2266C0.241699 12.8096 2.17523 10.8761 4.59215 10.8761H69.849C72.2659 10.8761 74.1994 12.8096 74.1994 15.2266V60.9063C74.1994 63.3232 72.0242 65.2568 69.849 65.2568Z"
          fill="#EAEEF9"
        />
        <path
          d="M63.565 80H10.6344C9.18429 80 7.97583 78.7915 7.97583 77.3414C7.97583 75.8912 9.18429 74.6827 10.6344 74.6827H63.565C65.0151 74.6827 66.2236 75.8912 66.2236 77.3414C65.9819 78.7915 65.0151 80 63.565 80Z"
          fill="#EAEEF9"
        />
        <path
          d="M66.4652 59.9396H7.73406C6.52561 59.9396 5.55884 58.9728 5.55884 57.7644V18.6103C5.55884 17.4018 6.52561 16.4351 7.73406 16.4351H66.4652C67.6736 16.4351 68.6404 17.4018 68.6404 18.6103V57.7644C68.6404 58.9728 67.6736 59.9396 66.4652 59.9396Z"
          fill="white"
        />
        <path
          d="M36.9788 42.5377C30.2115 42.5377 24.4109 47.6132 23.4441 54.3806C23.4441 55.3474 24.1692 56.0725 24.8942 56.0725H48.58C49.5468 56.0725 50.2719 55.3474 50.0302 54.3806C49.5468 47.6132 43.9879 42.5377 36.9788 42.5377Z"
          fill="#00C4B3"
        />
        <path
          d="M47.3717 35.287C47.3717 41.0876 42.7795 45.6798 36.9789 45.6798C31.1783 45.6798 26.5862 41.0876 26.5862 35.287C26.5862 29.4864 31.1783 24.8943 36.9789 24.8943C42.7795 24.8943 47.3717 29.4864 47.3717 35.287Z"
          fill="white"
        />
        <path
          d="M44.2295 35.287C44.2295 39.3958 40.8459 42.5378 36.9788 42.5378C32.87 42.5378 29.728 39.1541 29.728 35.287C29.728 31.1782 32.87 28.0363 36.9788 28.0363C41.0875 28.0363 44.2295 31.1782 44.2295 35.287Z"
          fill="#00C4B3"
        />
        <path
          d="M53.1722 23.2024L48.8217 33.5951C48.58 33.8368 49.0634 34.3202 49.3051 34.0785L66.7069 23.2024H53.1722Z"
          fill="#00416B"
        />
        <path
          d="M77.8247 26.1027H46.4047C45.1963 26.1027 44.2295 25.136 44.2295 23.9275V2.17523C44.2295 0.966767 45.1963 0 46.4047 0H77.583C78.7914 0 79.7582 0.966767 79.7582 2.17523V23.9275C79.9999 25.136 79.0331 26.1027 77.8247 26.1027Z"
          fill="#00416B"
        />
        <path
          d="M62.5981 13.2931C58.4894 13.2931 55.1057 16.4351 54.6223 20.3022C54.6223 20.7855 55.1057 21.2689 55.5891 21.2689H69.6072C70.0906 21.2689 70.574 20.7855 70.574 20.3022C70.0906 16.4351 66.7069 13.2931 62.5981 13.2931Z"
          fill="#FBFCFE"
        />
        <path
          d="M68.6405 8.94256C68.6405 12.3262 65.9819 15.2265 62.3565 15.2265C58.9728 15.2265 56.0725 12.5679 56.0725 8.94256C56.0725 5.55887 58.7311 2.65857 62.3565 2.65857C65.9819 2.90026 68.6405 5.55887 68.6405 8.94256Z"
          fill="#00416B"
        />
        <path
          d="M66.9487 8.94262C66.9487 11.3595 65.0152 13.2931 62.5983 13.2931C60.1813 13.2931 58.2478 11.3595 58.2478 8.94262C58.2478 6.5257 60.1813 4.59216 62.5983 4.59216C65.0152 4.59216 66.9487 6.5257 66.9487 8.94262Z"
          fill="#FBFCFE"
        />
      </g>
      <defs>
        <clipPath id="clip0_5_5252">
          <rect width="80" height="80" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
